import React, { useState,useEffect } from "react";
import { Form, Table, Image } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import MenuItem from "@material-ui/core/MenuItem";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
// import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import Media from "react-media";
import Pagination from "rc-pagination";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import { BottomNavigationMobile } from "../navigationSection/BottomNavigationMobile";
import { RightSideCountTop } from "../../superAdminComponents/superAdminAllComponent/superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import { vendor_all_seating_report } from "../../../store/actions/VendorReports/vendorReportsRestaurant";
import isEmpty from "../../../store/validation/is-Empty";
import SmallLoader from "../../Loader/SmallLoader";
import { ORDER_TYPE } from "../../../enums/OrderEnums";
import moment from "moment";
import { SortComponent } from "../../reusableComponents/SortAndFilterComponent/SortComponent";
import SelectFilter from '../../reusableComponents/selectFilter';
import BasicPagination from "../../Pagination/Pagination";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import CSVDownloader from "../../reusableComponents/csvDownload/csvDownload";
function AllSeatingReport(props) {


  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [dateQuery, setDateQuery] = useState({
    // startDate: moment().format("YYYY-MM-DD"),
    // endDate: moment().format("YYYY-MM-DD"),
  });
  const [state, setState] = useState({
    search: "",
  });
  const [anchorEl,setAnchorEl] = useState(null);
  const [restaurantReverse,setRestaurantReverse] = useState("");
 ;

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
  }

  const onSearchChange = (e) => {
    
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
    
  };

  const getData=()=>{
    props.vendor_all_seating_report(props.auth.user.accessToken,dateQuery);
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (value) => (e) => {
    setRestaurantReverse(value);
    console.log(restaurantReverse);
    handleClose();
  };

  useEffect((async) => {
    const DateForm = {
      startDate : moment().format("YYYY-MM-DD"),
      endDate : moment().format("YYYY-MM-DD"),
    }
    if(!isEmpty(dateQuery)){
      getData(props.auth.user.accessToken,dateQuery.startDate === 'undefined' ? DateForm : dateQuery);
    }
    
    
  }, [dateQuery]);

    // filter data//
    const [showFilter, setShowFilter] = useState(false);

    const [filter, setFilter] = useState({
      requestType: "",
      search: false,
    });
  
    const FilterRender = () => {
      console.log(filter);
      setFilter({
        ...filter,
        search: true,
      });
      setShowFilter(!showFilter);
    };

  let tempdata = [];
  // console.log(restaurantReverse);
  if (restaurantReverse === "A-Z") {
   tempdata = props?.allseating?.dinerRecords && props?.allseating?.dinerRecords.sort((a, b) => {
      
      if(a.users?.first_name !== null && b.users?.first_name !== null){
           if (a.users?.first_name < b.users?.first_name) return -1;
          if (a.users?.first_name > b.users?.first_name) return 1;
          return 0;
      }
     
    });
  } else if (restaurantReverse === "Z-A") {
    tempdata = props?.allseating?.dinerRecords && props?.allseating?.dinerRecords.sort((a, b) => {
      
      if(a.users?.first_name !== null && b.users?.first_name !== null){
        if (a.users?.first_name < b.users?.first_name) return 1;
       if (a.users?.first_name > b.users?.first_name) return -1;
       return 0;
   }
    });
  }


   tempdata = props?.allseating?.dinerRecords && props?.allseating?.dinerRecords.filter((data) =>{
      return(
        data?.users?.first_name?.toLowerCase().includes(state.search.toLowerCase())
      )
   })
   .filter((i) => {
    if (filter?.requestType) {
      return i.service_type === filter?.requestType;
    } else {
      return i;
    }
  });;

   const arrayUniqueByKey = [
    ...new Map(
      props?.allseating?.dinerRecords?.map((item) => [
        item["service_type"],
        item,
      ])
    ).values(),
  ];

      // download data
      const downloadData = {
        headers: [
          { label: "Request  Type \n Request  ID", key: "reqType" },
          { label: "User", key: "user" },
          { label: "Total PAX", key: "pax" },
          { label: "Request Status  \n Date & Time", key: "reqStatus" },
          { label: "Seating Preference", key: "seatingpreference" },
          { label: "Table/ \n Room No", key: "tableno" },
          { label: "Payment Type \n Transaction ID", key: "paymenttype" },
        ],
        data: tempdata
          ? tempdata?.map((ele) => {
              return {
                reqType: `${[ele?.service_type]} \n ${ele?._id}`,
                user: `${ele?.users?.first_name || ""}  ${ele?.users?.last_name || ""}`,
                pax: parseInt(ele?.kids_count)+parseInt(ele?.adult_count)+parseInt(ele?.high_chair)+parseInt(ele?.handicap_chair),
                reqStatus: `${ele?.diner_status} \n ${moment(ele?.createdAt).format("Do MMM YYYY")} \n ${moment(ele?.createdAt).format("hh:mm A")}`,
                seatingpreference: ele?.seating_preference[0],
                tableno: `${ele?.table_number || ""} - ${ele?.room_number || ""}`,
                paymenttype: `Scan & Pay \n 1245789632`,
              };
            })
          : [],
      };

  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">All Seating Report</div>
                <div>
                  <div
                    className="f14-500 mb-2 d-flex justify-content-end align-items-end"
                    style={{ color: "#EE3A23" }}
                  >
                    {moment().format('lll')}
                  </div>
                  <RightSideCountTop
                    content={[
                      {
                        name: <>Total No. of PAX</>,
                        value: props?.allseating?.totalPax,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Completed Requests",
                        value: props?.allseating?.completedRequest,
                        backgroundColor: "#D8F3F4",
                        color: "#138B90",
                      },
                    ]}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                    <Paper component="form" className="enSearch2 d-flex">
                      <IconButton type="submit" aria-label="search">
                        <SearchIcon />
                      </IconButton>
                      <InputBase
                        placeholder="Search"
                        name="search"
                        inputProps={{
                          "aria-label": "Search by Name or Phone Number",
                        }}
                        onChange={onSearchChange}
                        value={state.search}
                      />
                    </Paper>
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    <SelectFilter 
                      onDateChange={onDateChangeHandler()} 
                    />
                  </div>
                </div>
                <div className="col-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="f10-400" align="center">
                    <SortComponent
                        handleClick={handleClick}
                        anchorEl={anchorEl}
                        handleClose={handleClose}
                        selectClick={(data) => handleSelect(data)}
                      />
                    </div>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../assets/images/iconButton/filtericon.png")}
                        width="35px"
                        onClick={() => setShowFilter(!showFilter)}
                      />
                      <br />
                      Filter
                    </div>
                    <CSVDownloader
                        filename={"All Seating Report"}
                        headers={downloadData.headers}
                        data={downloadData.data}
                      />
                  </div>
                </div>
              </div>
              {showFilter && (
                  <div
                    className="container-fluid p-4"
                    style={{
                      backgroundColor: "#ffffff",
                      transition: "height 2s",
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <Form.Group>
                          <FormControl variant="outlined" className="w-100">
                            <InputLabel htmlFor="outlined-Status">
                              Request Type
                            </InputLabel>
                            <Select
                              value={filter.requestType}
                              onChange={(e) =>
                                setFilter({
                                  ...filter,
                                  requestType: e.target.value,
                                })
                              }
                              label="Request Type "
                              inputProps={{
                                name: "Request Type ",
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              {arrayUniqueByKey &&
                                arrayUniqueByKey?.map((data1, index1) => {
                                  console.log(
                                    data1,
                                    "*************data1**************"
                                  );
                                  return (
                                    <MenuItem
                                      value={data1?.service_type}
                                      key={index1}
                                    >
                                      {data1?.service_type}
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="mt-5 d-flex">
                      <button
                        type="button"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                        title="Cancel Button"
                        onClick={() => {
                          setFilter({
                            requestType: "",
                            search: false,
                          });
                          setShowFilter(!showFilter);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                        title="Confirm Button"
                        onClick={FilterRender}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                )}
              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table className="HideShowTable enMinWidth900">
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "280px" }} className="f12-700">
                          Request Type/
                          <br /> Request ID
                        </th>
                        <th style={{ width: "280px" }} className="f12-700">
                          User
                        </th>
                        <th style={{ width: "280px" }} className="f12-700">
                          Total PAX
                        </th>
                        <th style={{ width: "280px" }} className="f12-700">
                          Request
                          <br /> Status
                        </th>
                        <th style={{ width: "280px" }} className="f12-700">
                          Seating
                          <br /> Preference
                        </th>
                        <th style={{ width: "280px" }} className="f12-700">
                          Table/ <br />
                          Room No
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Payment Type/
                          <br /> Transaction ID
                        </th>
                      </tr>
                    </thead>
                    {props.auth.secondary_loader ? <SmallLoader/> : !isEmpty(tempdata) && tempdata.slice(start,end).map((data, index) => {
                      // console.log(data);
                    return (
                    <tbody key={index}>
                      <tr className="super_admin_all_users_table_body">
                        <td style={{ width: "280px" }} className="f12-500">
                          <div className="super-admin-suggestion-table-body-boxone d-flex align-items-center">
                            <div className="super-admin-suggestion-imageBoxTwo ml-2">
                              <div className="f12-400">
                                <b>{data?.service_type}</b>
                                <br />
                                {data?._id}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td style={{ width: "280px" }} className="f12-500">
                          {data?.users?.first_name}&nbsp;{data?.users?.last_name}
                        </td>
                        {/* <td style={{ width: "20%" }} className="f12-500">
                            
                        </td> */}
                        <td style={{ width: "280px" }}>
                          <div className="">
                            <div className="seating-dashboard-body-new">
                              <div className="total-pax-body">
                                <div className="col d-flex p-0">
                                  <div className="total-pax-body-inside">
                                    <h4 className="font_24_b">{parseInt(data?.kids_count)+parseInt(data?.adult_count)+parseInt(data?.high_chair)+parseInt(data?.handicap_chair)}</h4>
                                    {/* <p className="total-pax-light-text">PAX</p> */}
                                  </div>
                                  <div className="total-adult-kids">
                                    <div className="display-align">
                                      <Image
                                        src={require("../../../assets/images/ActionImages/image/adult.svg")}
                                        alt="Adult"
                                        title="Adult"
                                        className="pax-type-Image"
                                      />
                                      <p className="font_12_m ml-1 mr-1">{data?.adult_count}</p>
                                    </div>
                                    <div className="display-align">
                                      <Image
                                        src={require("../../../assets/images/ActionImages/image/kids.svg")}
                                        alt="Kids"
                                        title="Kids"
                                        className="pax-type-Image"
                                      />
                                      <p className="font_12_m ml-1 mr-1">{data?.kids_count}</p>
                                    </div>
                                  </div>
                                  <div className="total-highchair-handicapp">
                                    {/* {props.dinerInfo.high_chair === 0 ? null : ( */}
                                    <div className="display-align">
                                      <Image
                                        src={require("../../../assets/images/ActionImages/image/highchair.svg")}
                                        alt="Highchair"
                                        title="Highchair"
                                        className="pax-type-Image"
                                      />
                                      <p className="font_12_m ml-1 mr-1">{data?.high_chair}</p>
                                    </div>
                                    {/* )}
                          {props.dinerInfo.handicap_chair === 0 ? null : ( */}
                                    <div className="display-align">
                                      <Image
                                        src={require("../../../assets/images/ActionImages/image/handicap.svg")}
                                        alt="Handicapped"
                                        title="Handicapped"
                                        className="pax-type-Image"
                                      />
                                      <p className="font_12_m ml-1 mr-1">{data?.handicap_chair}</p>
                                    </div>
                                    {/* )} */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td style={{ width: "280px" }} className="f12-500">
                          <div className="super-admin-suggestion-imageBoxTwo ml-2">
                          <div
                              // className="badge badge-success p-2"
                              // style={{ borderRadius: "1rem" }}
                            >
                              {data?.diner_status}
                            </div>
                            {/* {data?.diner_status  = "COMPLETED" ? 
                            <div
                              className="badge badge-success p-2"
                              style={{ borderRadius: "1rem" }}
                            >
                              {data?.diner_status}
                            </div>
                            : null }
                             {data?.diner_status  = "PENDING" ? 
                            <div
                              className="badge badge-warning p-2"
                              style={{ borderRadius: "1rem" }}
                            >
                              {data?.diner_status}
                            </div>
                            : null }
                            <div
                              className="badge badge-danger p-2"
                              style={{ borderRadius: "1rem" }}
                            >
                              {data?.diner_status}
                            </div> */}
                            <div className="f12-400">
                              {moment(data?.createdAt).format("YYYY-MM-DD")}
                            </div>
                            <div className="f12-400">
                              {moment(data?.createdAt).format("hh:mm:A")}
                            </div>
                          </div>
                        </td>
                        <td style={{ width: "280px" }} className="f12-500">
                          {data?.seating_preference[0]}
                        </td>
                        <td style={{ width: "280px" }} className="f12-500">
                           {data?.table_number} - {data?.room_number} 
                        </td>
                        <td style={{ width: "15%" }}>
                          <div className="super-admin-suggestion-table-body-boxone d-flex align-items-center">
                            <div className="super-admin-suggestion-imageBoxTwo ml-2">
                              <div className="f12-400">
                                <b>Scan & Pay</b>
                                <br />
                                <b>1245789632</b>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    );
                  })}
                  </Table>
                </div>
              </div>

              <div className="p4v2-menu-pagination">
                <BasicPagination
                  totalRecords={props?.allseating?.dinerRecords?.length}
                  limit={5}
                  batch={page}
                  onBatchChange={(e) => handleBatchChange(e)}
                />
              </div>
            </div>
          </div>
          <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media>
        </div>
      </div>
    </React.Fragment>
  );
}

AllSeatingReport.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  allseating: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  allseating: state.reports.vendor_all_Seating,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  vendor_all_seating_report,
})(AllSeatingReport);

// export default AllSeatingReport;
